export default __webpack_public_path__ + "static/media/NAR-BNB.70ad5575.png";